import React, { useEffect, useState } from "react";
import { Form, Input, Button, Select, Card, message } from "antd";
import "antd/dist/antd.css";
import { professionalAction } from "../../_actions";
import _ from "lodash";

const { Option } = Select;

export const VerificationForm = (props) => {
  const [form] = Form.useForm();

  const onFormFinish = (values) => {
    const currentDate = new Date();
    const durationYears = parseInt(values.subscription_duration);
    const expiryDate = new Date(
      currentDate.setFullYear(currentDate.getFullYear() + durationYears)
    )
      .toISOString()
      .split("T")[0];

    const requestData = {
      module_name: values.module_name,
      email: values.email,
      cityId: values.unitName,
      unit_name:
        props.units.find((unit) => unit.cityId === values.unitName)
          ?.city_name[0]?.City || "",
      plan: values.plan,
      subscription_duration: values.subscription_duration,
      expriy_date: expiryDate,
    };

    professionalAction
      .saveVerificationAllocation(requestData)
      .then((data) => {
        message.success("Successfully Submitted");
        form.resetFields();
        props.toggleActive();
        props.getAllocatedVerificationList();
      })
      .catch((error) => {
        console.error("Error in saving verification allocation:", error);
      });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFormFinish}
      initialValues={{
        module_name: "Verification Module",
      }}
    >
      <Form.Item label="Module Name:" name="module_name">
        <Input
          placeholder="Verification Module"          
          readOnly
        />
      </Form.Item>

      <Form.Item
        label="Unit E Mail ID"
        name="email"
        rules={[
          {
            required: true,
            message: "Please input your government email!",
          },
          {
            type: "email",
            message: "The input is not valid E-mail!",
          },
        ]}
      >
        <Input placeholder="Enter Gov. Email ID Only" />
      </Form.Item>

      <Form.Item
        label="Select Unit Name"
        name="unitName"
        rules={[{ required: true, message: "Please select your unit!" }]}
      >
        <Select
          placeholder="Please select Unit"
          rules={[{ required: true, message: "Please select Unit" }]}
        >
          {props.units &&
            props.units.length &&
            props.units.map((res) => {
              const isDisabled = props.data.some(
                (item) => item.cityId === res.cityId
              );

              return (
                <Option key={res.id} value={res.cityId} disabled={isDisabled}>
                  {res.city_name[0]?.City}
                </Option>
              );
            })}
        </Select>
      </Form.Item>

      <Form.Item
        label="Plan"
        name="plan"
        rules={[{ required: true, message: "Please select your plan!" }]}
      >
        <Select placeholder="Select Plan">
          <Option value="Plan A">Plan A: only for Unit Admin</Option>
          <Option value="Plan B">
            Plan B: Unit admin and Police Station User
          </Option>
          <Option value="Plan C">
            Plan C: Unit admin, police station and all app users
          </Option>
        </Select>
      </Form.Item>

      <Form.Item
        label="Subscription Duration"
        name="subscription_duration"
        rules={[
          {
            required: true,
            message: "Please select your subscription duration!",
          },
        ]}
      >
        <Select placeholder="Select Duration">
          <Option value="1 Year">1 Year</Option>
          <Option value="2 Years">2 Years</Option>
          <Option value="3 Years">3 Years</Option>
        </Select>
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" block>
          Activate Now
        </Button>
      </Form.Item>
    </Form>
  );
};
